export const FONT_WEIGHT_NAMES: Record<number, string> = {
  100: "Thin",
  200: "ExtraLight",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semibold",
  700: "Bold",
  800: "ExtraBold",
  900: "Black",
};

/** BEE's own weight labels, written into `beeFonts` for the email editor. */
export const BEE_FONT_WEIGHT_LABELS: Record<number, string> = {
  100: "Thin",
  200: "Extra-light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi-bold",
  700: "Bold",
  800: "Extra-bold",
  900: "Black",
};

export const FONT_SOURCE_LABELS = { google: "Google font", adobe: "Adobe font" } as const;

export const FONT_SAMPLE_TEXT = "Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv Ww Xx Yy Zz";

export const INVALID_PROJECT_ID_MESSAGE = "Invalid Project ID";

export const getTypekitStylesheetUrl = (projectId: string) => `https://use.typekit.net/${projectId}.css`;
